module.exports = __webpack_public_path__ + "img/冲压车间3.83bcad14.jpg";